import axios from "axios";
import { Client } from "client-sdk/src";
import handleError from "../../../utils/handleError";
import { GetTPLsRequestBuilder } from "client-sdk/src/entrances/getTPLs";

const token = localStorage.getItem("token");

export async function getTPLs() {
  try {
    const getTPLsList = new GetTPLsRequestBuilder()
      .build();
    const client = new Client(token as string);
    const response = client.execute(
      getTPLsList,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}

export default getTPLs;
